import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function unarchiveTopic(id: string) {
  const { error } = await apiClient
    .from('topics')
    .update({
      archived: false
    })
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useUnarchiveTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (topicId: string) => unarchiveTopic(topicId),
    onSuccess: (_data, topicId) => {
      enqueueSnackbar('Sujet désarchivé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(false) })
      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(true) })
      queryClient.invalidateQueries({ queryKey: keys.topicListPagedAll() })
      queryClient.invalidateQueries({ queryKey: keys.topic(topicId) })
      queryClient.invalidateQueries({ queryKey: keys.subTopicList() })
    }
  })
}
